import { render, staticRenderFns } from "./GiftTransferList.vue?vue&type=template&id=24814675&scoped=true&"
import script from "./GiftTransferList.vue?vue&type=script&lang=js&"
export * from "./GiftTransferList.vue?vue&type=script&lang=js&"
import style0 from "./GiftTransferList.vue?vue&type=style&index=0&id=24814675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24814675",
  null
  
)

export default component.exports